import { SECONDARY_NAV_SCHEMAS } from './secondaryNavSchemas.js'

export function getSecondarySchema(activeKey) {
  return SECONDARY_NAV_SCHEMAS[activeKey] ?? SECONDARY_NAV_SCHEMAS.home
}
